import React from 'react';
import { Link } from 'react-router';
import img from '../helpers/img';
import '../styles/Zak.scss';

const Zak = () => {
  const name = 'Zak Fisher';
  const desc = 'Full Stack Engineer, UX Specialist, Entrepreneur';
  const imgPath = img('zak.png');
  return (
    <div className="Zak col-12 tab-6">
      <Link to={`/`}>
        <img src={imgPath} alt={name} />
      </Link>
      <h1>{name}</h1>
      <h2>{desc}</h2>
    </div>
  );
}

export default Zak;



// WEBPACK FOOTER //
// ./src/components/Zak.js